module.exports = require('./helpers/bundle-url').getBundleURL('hKhd1') + "logo-dark.ba5147f0.svg";